import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { UserGroupService } from 'src/app/settings/services/user-group.service';
import { ClientSettingsService } from '../services/auth/client-settings.service';
import { AppSettings } from '../../shared/constants/app-settings.constants';

@Injectable({
    providedIn: 'root',
})
export class AssetGuard {
    constructor(
        private router: Router,
        private userGroupService: UserGroupService,
        private clientSettingsService: ClientSettingsService,
    ) { }
    canActivate(state: RouterStateSnapshot) {
      if (this.userGroupService.isUserLeadOrgAdmin() || this.clientSettingsService.get(AppSettings.IsAssetRegisterViewEnabled, false)) {
            return true;
        } else {
            this.router.navigate(['/sign-in'], {
                queryParams: { returnUrl: state.url },
            });
            return false;
        }
    }
}
